import React, { useEffect, useState } from 'react';
import { FaArrowUp, FaGlobe } from 'react-icons/fa';

const SortHeader = (props: any) => {
  const { displayName, enableSorting, column, progressSort,icon } = props;
  const [sort, setSort] = useState(column.getSort());

  useEffect(() => {
    const onSortChanged = () => {
      setSort(column.getSort()); 
    };

    column.addEventListener('sortChanged', onSortChanged);
    return () => {
      column.removeEventListener('sortChanged', onSortChanged);
    };
  }, [column]);

  return (
    <div
      className="flex items-center justify-between w-full cursor-pointer"
      onClick={() => {
        if (enableSorting) progressSort();
      }}
    >
      <div className="flex items-center gap-2">
        {icon ?? <FaGlobe className="text-gray-600" />}
        <span>{displayName}</span>
      </div>

      <FaArrowUp
        className={`ml-2 text-gray-600 transition-transform duration-200 ${
          sort === 'desc' ? 'rotate-180' : ''
        } ${!sort ? 'opacity-30' : ''}`} 
      />
    </div>
  );
};
  
export default SortHeader;

